import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center w-full mt-10" }
const _hoisted_2 = { class: "mx-auto space-y-2 md:space-y-4" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "flex mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  class: "w-4",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label", "onClick"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "w-4",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]

import { PropType, ref } from "vue";
import { useRoute } from "vue-router";

import router from "@/router";
import { PaginationMeta } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationBar',
  props: {
  meta: {
    type: Object as PropType<PaginationMeta>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();



const paginationArray = ref([] as number[]);
const current_page = ref(props.meta.pagination?.current_page);

function getMiddlePages(total_pages: number) {
  // return 3 pages before and after current page
  const currentPage = Number(props.meta.pagination?.current_page);

  for (let i = currentPage - 1; i <= currentPage + 1; i++) {
    if (i > 0 && i <= total_pages && i !== 1) {
      paginationArray.value.push(i);
    }
  }
}

async function goToPreviousPage() {
  const query = { ...route.query, page: props.meta.pagination?.current_page - 1 };
  return await router.push({ name: route.name!, query: query }).then(() => location.reload());
}

async function goToPage(page: number) {
  const query = { ...route.query, page: page };
  return await router.push({ name: route.name!, query: query }).then(() => location.reload());
}

async function goToNextPage() {
  const query = { ...route.query, page: props.meta.pagination?.current_page + 1 };
  return await router.push({ name: route.name!, query: query }).then(() => location.reload());
}

getMiddlePages(props.meta.pagination?.total_pages!);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('total-meta-pagination-total_entries-items', [__props.meta.pagination?.total_entries])), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          "aria-label": "Go to previous page",
          onClick: goToPreviousPage,
          class: _normalizeClass(["flex items-center px-4 py-2 list-none border border-gray-400 rounded-l text-blue", { 'pointer-events-none': current_page.value - 1 <= 0 }])
        }, _hoisted_6, 2),
        (__props.meta.pagination.total_pages <= 8)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.meta.pagination?.total_pages, (p) => {
              return (_openBlock(), _createElementBlock("button", {
                "aria-label": `Go to page ${p}`,
                key: p,
                onClick: ($event: any) => (goToPage(p)),
                class: _normalizeClass([p === current_page.value ? 'text-white bg-primary' : 'text-blue bg-white', "px-4 py-2 list-none border border-gray-400"])
              }, _toDisplayString(p), 11, _hoisted_7))
            }), 128))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("button", {
                "aria-label": "Go to page 1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage(1))),
                class: "px-4 py-2 list-none bg-white border border-gray-400 text-primary"
              }, "1"),
              (__props.meta.pagination.current_page > 5)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(paginationArray.value[0] - 1))),
                    "aria-label": `Go to page ${paginationArray.value[0] - 1}`,
                    class: "px-4 py-2 list-none bg-white border border-gray-400 text-primary"
                  }, " ... ", 8, _hoisted_8))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationArray.value, (p) => {
                return (_openBlock(), _createElementBlock("button", {
                  "aria-label": `Go to page ${p}`,
                  key: p,
                  onClick: ($event: any) => (goToPage(p)),
                  class: _normalizeClass([p == current_page.value ? 'text-white bg-primary' : 'text-blue bg-white', "px-4 py-2 list-none border border-gray-400"])
                }, _toDisplayString(p), 11, _hoisted_9))
              }), 128)),
              (!paginationArray.value.includes(__props.meta.pagination.total_pages - 1))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    "aria-label": `Go to page ${paginationArray.value[paginationArray.value.length - 1] + 1}`,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(paginationArray.value[paginationArray.value.length - 1] + 1))),
                    class: "px-4 py-2 list-none bg-white border border-gray-400 text-blue"
                  }, " ... ", 8, _hoisted_10))
                : _createCommentVNode("", true),
              (!paginationArray.value.includes(__props.meta.pagination.total_pages))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    "aria-label": `Go to page ${__props.meta.pagination.total_pages}`,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage(__props.meta.pagination.total_pages))),
                    class: "px-4 py-2 list-none bg-white border border-gray-400 text-blue"
                  }, _toDisplayString(__props.meta.pagination.total_pages), 9, _hoisted_11))
                : _createCommentVNode("", true)
            ], 64)),
        _createElementVNode("button", {
          "aria-label": "Go to next page",
          onClick: goToNextPage,
          class: _normalizeClass(["flex items-center px-4 py-2 list-none border border-gray-400 rounded-r text-blue", { 'pointer-events-none': __props.meta.pagination.total_pages < current_page.value + 1 }])
        }, _hoisted_13, 2)
      ])
    ])
  ]))
}
}

})